import React, { useEffect, useState } from "react";

// Shown whenever the current localStorage session came from a super
// admin "Enter as admin" click. Reads `impersonation` + `saOwnerToken`
// out of localStorage rather than a context so it works at the very top
// of the tree without new providers.
export default function ImpersonationBanner() {
  const [meta, setMeta] = useState(null);

  useEffect(() => {
    try {
      const raw = localStorage.getItem("impersonation");
      if (raw) setMeta(JSON.parse(raw));
    } catch (e) {
      setMeta(null);
    }
  }, []);

  if (!meta) return null;

  const returnToOwner = () => {
    const saToken = localStorage.getItem("saOwnerToken");
    const saUser = localStorage.getItem("saOwnerUser");
    if (saToken) localStorage.setItem("token", saToken);
    if (saUser) localStorage.setItem("user", saUser);
    localStorage.removeItem("saOwnerToken");
    localStorage.removeItem("saOwnerUser");
    localStorage.removeItem("impersonation");
    window.location.href = "/super-admin";
  };

  return (
    <div
      style={{
        position: "sticky",
        top: 0,
        zIndex: 1000,
        background:
          "linear-gradient(90deg, #ffd166 0%, #ffbe0b 50%, #ffd166 100%)",
        color: "#1a1a1a",
        padding: "8px 14px",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        fontSize: 13,
        borderBottom: "2px solid #b8860b",
        fontFamily:
          '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
      }}
    >
      <div>
        <strong>Super admin session:</strong> viewing <strong>{meta.orgName}</strong>
        {" "}as <strong>{meta.asUserEmail}</strong>
      </div>
      <button
        onClick={returnToOwner}
        style={{
          background: "#1a237e",
          color: "#fff",
          border: "none",
          padding: "6px 12px",
          borderRadius: 6,
          fontSize: 12,
          fontWeight: 600,
          cursor: "pointer",
        }}
      >
        Return to super admin
      </button>
    </div>
  );
}
